const routes = {
  getUserDashboard: 'dashboard/user',
  getAdminDashboard: 'dashboard/admin',
};

export default routes;
